import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';

export const nodeTypeMap: Record<NodeType, string> = {
  [NodeType.Start]: 'event',
  [NodeType.WaitDays]: 'event',
  [NodeType.WaitDayOfWeek]: 'event',
  [NodeType.WaitDaysForDueDate]: 'event',
  [NodeType.WaitDayOfMonth]: 'event',
  [NodeType.SendSMS]: 'activity',
  [NodeType.SendCertifiedSMS]: 'activity',
  [NodeType.SendEmail]: 'activity',
  [NodeType.SendCertifiedEmail]: 'activity',
  [NodeType.AssignCampaign]: 'activity',
  [NodeType.Conditional]: 'conditional',
  [NodeType.ConditionalSegments]: 'conditional',
  [NodeType.Experiment]: 'conditional',
  [NodeType.End]: 'event',
  [NodeType.Multi]: 'event',
  [NodeType.OfferPartialPayment]: 'activity',
  [NodeType.OfferPaymentAgreement]: 'activity',
  [NodeType.MakeOutBoundCall]: 'activity',
  [NodeType.CreateLegalClaim]: 'activity',
  [NodeType.CreateMasc]: 'activity',
};
